import React, { useRef } from "react";
import { useLoadScript, Autocomplete, GoogleMap, Marker } from "@react-google-maps/api";
import Spinner from "./Spinner";

const libraries = ["places"];

const GoogleMaps = ({ eventData, setEventData }) => {
	const autocompleteRef = useRef(null);

	const { isLoaded, loadError } = useLoadScript({
		googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
		libraries,
	});

	const onPlaceChanged = () => {
		if (!autocompleteRef.current) return;

		const place = autocompleteRef.current.getPlace();
		if (!place || !place.geometry) {
			console.warn("No place or geometry found");
			return;
		}

		const name = place.name;
		const lat = place.geometry.location.lat();
		const lng = place.geometry.location.lng();
		const address = place.formatted_address || place.name;
		const placeId = place.place_id;
		const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=15&size=600x300&markers=color:red|${lat},${lng}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;

		setEventData((prev) => ({
			...prev,
			name,
			lat,
			lng,
			address,
			placeId,
			staticMapUrl,
		}));
	};

	if (loadError) return <div>Error loading Google Maps</div>;
	if (!isLoaded) return <Spinner />;

	return (
		<div>
			{/* Location Input with Autocomplete */}
			<div className="mb-3">
				<label className="form-label">
					<i className="bi bi-geo-alt me-2" />
					Location
				</label>
				<Autocomplete
					onLoad={(autocomplete) => (autocompleteRef.current = autocomplete)}
					onPlaceChanged={onPlaceChanged}
				>
					<div className="position-relative">
						<input
							type="text"
							name="address"
							className="form-control bg-dark text-light"
							placeholder="Name or address of the venue"
							value={eventData.address || ""} // controlled value
							onChange={(e) =>
								setEventData((prev) => ({
									...prev,
									address: e.target.value, // update while typing
								}))
							}
							style={{ paddingRight: "30px" }}
							required
						/>
						{eventData.address && (
							<button
								type="button"
								className="btn btn-sm btn-link position-absolute top-50 end-0 translate-middle-y text-light"
								style={{ textDecoration: "none" }}
								onClick={() =>
									setEventData((prev) => ({
										...prev,
										address: "",
									}))
								}
							>
								<i className="bi bi-x-circle"></i>
							</button>
						)}
					</div>
				</Autocomplete>
			</div>

			{/* Map */}
			{eventData.lat && eventData.lng && (
				<GoogleMap
					mapContainerStyle={{
						width: "100%",
						height: "300px",
						marginTop: "1rem",
						borderRadius: "10px",
						overflow: "hidden",
					}}
					center={{ lat: eventData.lat, lng: eventData.lng }}
					zoom={15}
				>
					<Marker position={{ lat: eventData.lat, lng: eventData.lng }} />
				</GoogleMap>
			)}

			{/* Venue Name Input */}
			<div className="my-3">
				<label className="form-label">
					<i className="bi bi-building me-2" />
					Venue Name
				</label>
				<input
					type="text"
					name="name"
					className="form-control bg-dark text-light"
					value={eventData.name}
					onChange={(e) => setEventData((prev) => ({ ...prev, name: e.target.value }))}
					placeholder="Enter the name of the venue"
					required
				/>
			</div>
		</div>
	);
};

export default GoogleMaps;
